import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CopaOro = ({ isAdmin }) => {
  const [categorias, setCategorias] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [playoffData, setPlayoffData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disponibilidad, setDisponibilidad] = useState(null);

  useEffect(() => {
    fetchCategorias();
  }, []);

  const fetchCategorias = async () => {
    try {
      const response = await axios.get(`${API}/categorias`);
      setCategorias(response.data);
    } catch (error) {
      console.error('Error al obtener categorías:', error);
    }
  };

  const verificarDisponibilidad = async (categoria) => {
    try {
      const response = await axios.get(`${API}/playoffs/disponible/${categoria}`);
      setDisponibilidad(response.data);
    } catch (error) {
      console.error('Error al verificar disponibilidad:', error);
      setDisponibilidad(null);
    }
  };

  const generarPlayoffs = async (categoria) => {
    setLoading(true);
    try {
      await axios.post(`${API}/playoffs/generar/${categoria}`);
      await fetchPlayoff(categoria);
      await verificarDisponibilidad(categoria);
      alert('Playoffs generados exitosamente');
    } catch (error) {
      console.error('Error al generar playoffs:', error);
      const errorMsg = error.response?.data?.detail || 'Error al generar playoffs';
      alert(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const fetchPlayoff = async (categoria) => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/playoffs/${categoria}/oro`);
      setPlayoffData(response.data);
      setCategoriaSeleccionada(categoria);
      await verificarDisponibilidad(categoria);
    } catch (error) {
      console.error('Error al obtener playoff:', error);
      setPlayoffData(null);
    } finally {
      setLoading(false);
    }
  };

  const cargarResultado = async (fase, partidoIdx) => {
    const goles1 = prompt('Goles Equipo 1:');
    const goles2 = prompt('Goles Equipo 2:');

    if (goles1 === null || goles2 === null) return;

    const g1 = parseInt(goles1);
    const g2 = parseInt(goles2);

    if (isNaN(g1) || isNaN(g2) || g1 < 0 || g2 < 0) {
      alert('Goles inválidos');
      return;
    }

    if (g1 === g2) {
      alert('No puede haber empates en playoffs');
      return;
    }

    try {
      await axios.post(`${API}/playoffs/resultado`, {
        categoria: categoriaSeleccionada,
        tipo: 'oro',
        fase: fase,
        partido_idx: partidoIdx,
        goles1: g1,
        goles2: g2
      });
      await fetchPlayoff(categoriaSeleccionada);
      alert('Resultado cargado exitosamente');
    } catch (error) {
      console.error('Error al cargar resultado:', error);
      alert(error.response?.data?.detail || 'Error al cargar resultado');
    }
  };

  const renderPartido = (partido, fase, idx) => {
    if (!partido) return null;

    const hasEquipos = partido.equipo1 && partido.equipo2;
    const hasResultado = partido.goles1 !== null && partido.goles2 !== null;

    return (
      <div key={partido.id || idx} className="playoff-partido">
        <div className={`playoff-equipo ${partido.ganador === partido.equipo1 ? 'ganador' : ''}`}>
          <span className="equipo-nombre">{partido.equipo1 || 'TBD'}</span>
          {hasResultado && <span className="equipo-goles">{partido.goles1}</span>}
        </div>
        <div className="vs-separator">vs</div>
        <div className={`playoff-equipo ${partido.ganador === partido.equipo2 ? 'ganador' : ''}`}>
          <span className="equipo-nombre">{partido.equipo2 || 'TBD'}</span>
          {hasResultado && <span className="equipo-goles">{partido.goles2}</span>}
        </div>
        {isAdmin && hasEquipos && !hasResultado && (
          <button 
            className="btn-cargar-resultado"
            onClick={() => cargarResultado(fase, idx)}
          >
            ⚽ Cargar Resultado
          </button>
        )}
      </div>
    );
  };

  const esExperimental = categoriaSeleccionada === '2019 experimental';

  return (
    <div className="copa-oro-container">
      <h2 className="copa-title">🏆 COPA DE ORO</h2>

      <div className="categoria-selector">
        <label>Seleccionar Categoría:</label>
        <select 
          value={categoriaSeleccionada || ''} 
          onChange={(e) => fetchPlayoff(e.target.value)}
        >
          <option value="">-- Seleccionar --</option>
          {categorias.map(cat => (
            <option key={cat.id} value={cat.año}>{cat.año}</option>
          ))}
        </select>
        
        {isAdmin && categoriaSeleccionada && disponibilidad && (
          <div className="disponibilidad-info">
            <p className={disponibilidad.disponible ? 'disponible' : 'no-disponible'}>
              {disponibilidad.disponible ? '✅' : '⏳'} {disponibilidad.mensaje}
            </p>
            {!disponibilidad.disponible && (
              <p className="progreso-info">
                Progreso: {disponibilidad.partidos_jugados}/{disponibilidad.partidos_totales} partidos 
                ({disponibilidad.porcentaje_completado}%)
              </p>
            )}
          </div>
        )}
        
        {isAdmin && categoriaSeleccionada && disponibilidad && disponibilidad.disponible && (
          <button 
            className="btn-generar-playoffs"
            onClick={() => generarPlayoffs(categoriaSeleccionada)}
            disabled={loading}
          >
            🔄 Generar/Regenerar Playoffs
          </button>
        )}
      </div>

      {loading && <p className="loading-text">Cargando...</p>}

      {playoffData && (
        <div className="playoff-bracket">
          {/* Cuartos de Final (solo categorías regulares) */}
          {!esExperimental && playoffData.fase.cuartos && (
            <div className="playoff-fase">
              <h3 className="fase-title">Cuartos de Final</h3>
              <div className="partidos-grid">
                {playoffData.fase.cuartos.map((partido, idx) => 
                  renderPartido(partido, 'cuartos', idx)
                )}
              </div>
            </div>
          )}

          {/* Semifinales */}
          <div className="playoff-fase">
            <h3 className="fase-title">Semifinales</h3>
            <div className="partidos-grid">
              {playoffData.fase.semifinales.map((partido, idx) => 
                renderPartido(partido, 'semifinales', idx)
              )}
            </div>
          </div>

          {/* Final */}
          <div className="playoff-fase">
            <h3 className="fase-title">🏆 FINAL DE ORO</h3>
            <div className="partidos-grid final-grid">
              {renderPartido(playoffData.fase.final, 'final', 0)}
            </div>
            {playoffData.fase.final.ganador && (
              <div className="campeon-container">
                <h2 className="campeon-title">🎉 CAMPEÓN: {playoffData.fase.final.ganador} 🎉</h2>
              </div>
            )}
          </div>
        </div>
      )}

      {!playoffData && categoriaSeleccionada && !loading && disponibilidad && (
        <p className="info-message">
          {disponibilidad.disponible 
            ? (isAdmin 
                ? '📌 Haz clic en "Generar Playoffs" para crear el bracket de esta categoría'
                : '📌 Los playoffs aún no han sido generados para esta categoría')
            : '📌 Los playoffs estarán disponibles cuando se completen las 13 fechas del torneo'}
        </p>
      )}
    </div>
  );
};

export default CopaOro;
